import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from 'sheets';

import styles from './IconBlock.css';

const IconBlock = (props) => {
  return (
    <figure className={styles.container}>
      <Icon
        className={styles.icon}
        name={props.icon}
      />
      <figcaption className={styles.title}>{props.title}</figcaption>
    </figure>
  );
};

IconBlock.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default IconBlock;
